module.exports = __webpack_public_path__ + "static/media/bts_lalela_170707_013_small.b88ba6af.jpg";